module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mosaic-container"
  }, _vm._l((_vm.rows), function(row) {
    return _c('div', {
      staticClass: "mosaic-row"
    }, _vm._l((_vm.cols), function(col) {
      return _c('div', [_c('image-loader', {
        attrs: {
          "url": _vm.getUrl(row, col),
          "width": _vm.imageWidth,
          "height": _vm.imageHeight,
          "hue": _vm.hue
        }
      })], 1)
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f94dc81e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mosaic.vue
// module id = 132
// module chunks = 2